export const saveSearchParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const paramsDict = {};

    let size = 0;
    urlParams.forEach((value, key) => {
        paramsDict[key] = value;
        size++;
    });

    console.log(`[saveSearchParams] got the search params as dictionary:`, paramsDict);
    if (size > 0) {
        const json = JSON.stringify(paramsDict);
        console.log(`[saveSearchParams] got size[${size}] search params. Saving the value:`, json);
        localStorage.setItem('savedAppSearchParams', json);
    } else {
        console.log(`[saveSearchParams] search params was empty`);
    }
};

export const updateSearchParams = (key, value) => {
    const json = localStorage.getItem('savedAppSearchParams');
    let paramsDict = {};
    if (json != undefined && json != '') {
        console.log(`[saveSearchParams] got the search params as dictionary:`, paramsDict);
        paramsDict = JSON.parse(json);
    }

    paramsDict[key] = value;
    const updateJson = JSON.stringify(paramsDict);
    console.log(`[updateSearchParams] updated saved search Params:`, updateJson);
    localStorage.setItem('savedAppSearchParams', updateJson);
};

export const deleteSearchParams = () => {
    localStorage.removeItem('savedAppSearchParams');
    localStorage.removeItem('SavedJoinCode');
};

export const clearStorageButSaveKeys = () => {
    // List of keys to save
    const keysToSave = ['overrideEnv', 'RunLocal'];

    // Create a dictionary to store the values of keys to save
    const savedData = {};
    keysToSave.forEach((key) => {
        const value = localStorage.getItem(key);
        if (value !== null) {
            savedData[key] = value;
        }
    });

    // Clear all localStorage
    localStorage.clear();

    // Re-add the saved keys and their values back to localStorage
    Object.entries(savedData).forEach(([key, value]) => {
        localStorage.setItem(key, value);
    });
};
